import {
  Footer as InternalFooter
} from '@lessonnine/design-system.lib';

import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions';
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem';

const Footer = {
  [DS_VERSIONS.default]: InternalFooter
};

export default Footer[CURRENT_DS_VERSION];
